import { render, staticRenderFns } from "./classschedule.vue?vue&type=template&id=69d845aa&scoped=true"
import script from "./classschedule.vue?vue&type=script&lang=js"
export * from "./classschedule.vue?vue&type=script&lang=js"
import style0 from "./classschedule.vue?vue&type=style&index=0&id=69d845aa&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d845aa",
  null
  
)

export default component.exports